import logo2004_2005 from "../../assets/img/historicEvents/LogoGAB/2004-2005.png";
import logo2006 from "../../assets/img/historicEvents/LogoGAB/2006.png";
import logo2007 from "../../assets/img/historicEvents/LogoGAB/2007.png";
import logo2008 from "../../assets/img/historicEvents/LogoGAB/2008.png";
import logo2009 from "../../assets/img/historicEvents/LogoGAB/2009.png";
import logo2012 from "../../assets/img/historicEvents/LogoGAB/2012.png";

export const greatAmericanBashDetail = {
  "great-american-bash": {
    id: "great-american-bash",
    title: "Great American Bash",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "great-american-bash",
        items: [
          {
            id: "great-american-bash-2004",
            title: "The Great American Bash",
            description: "Join Our Party 2004",
            imgUrl: logo2004_2005,
          },
          {
            id: "great-american-bash-2005",
            title: "The Great American Bash",
            description: "2005",
            imgUrl: logo2004_2005,
          },
          {
            id: "great-american-bash-2006",
            title: "The Great American Bash",
            description: "2006",
            imgUrl: logo2006,
          },
          {
            id: "great-american-bash-2007",
            title: "The Great American Bash",
            description: "2007",
            imgUrl: logo2007,
          },
          {
            id: "great-american-bash-2008",
            title: "The Great American Bash",
            description: "2008",
            imgUrl: logo2008,
          },
          {
            id: "great-american-bash-2009",
            title: "The Bash",
            description: "2009",
            imgUrl: logo2009,
          },
          {
            id: "great-american-bash-2012",
            title: "Super SmackDown Live",
            description: "The Great American Bash 2012",
            imgUrl: logo2012,
          },
        ],
      },
    ],
  },
};
